// this is ES6 syntax, it's essentially equivalent to: var React =
// require('react')
import React from 'react';
import {reduxForm, Field} from 'redux-form' // imported Field

//Controls
import Controls from "utils/renderControl.js";

//Validation function
import validate from "./validate";

//Times of day
import Times from "utils/times";

import DaysOfTheWeek from "utils/days";

import {normalizeMoney} from "utils/normalize";

class EmploymentDesired extends React.Component {

		constructor(props) {
				super(props);
		}

		//now this component is getting passed props from the AppContainer
		static propTypes = {
				config: React.PropTypes.object,
				location: React.PropTypes.object,
				onSubmit: React.PropTypes.func
		};

		componentDidMount() {
				setTimeout(function () {
						if (this.props.location.query.validate) {
								const submitter = this
										.props
										.handleSubmit(this.props.onSubmit)
								submitter() // submits
						}
				}.bind(this), 100)
		}

		render() {
				const {handleSubmit, pristine, reset, submitting} = this.props;

				return (
						<form id="employment-desired" onSubmit={handleSubmit}>
								<h2>Employment Desired/Availability</h2>
								{/************************
					* MOBILE - PREVIOUS/NEXT
					*************************/}
								<div className="actions-mobile clearfix visible-xs-block">
										<a disabled={submitting} className="prev" onClick={this.props.goToPrevious}>
												<i className="fa fa-chevron-left" aria-hidden="true"></i>
												Previous
										</a>
										<button type="submit" disabled={submitting} className="btn">
												Next
												<i className="fa fa-chevron-right" aria-hidden="true"></i>
										</button>
								</div>

								{/************************
					* POSITION DESIRED/DATE AVAILABLE
					*************************/}
								<div className="row">
										<Field
												name="positionDesired"
												type="text"
												wrapperClassName="col-sm-5 required"
												component={Controls.select}
												props={{
												label: "Position Desired",
												placeholder: "Select Position"
										}}>
												<option value="Box Office/Guest Service">Box Office/Guest Service</option>
												<option value="Usher">Usher</option>
												<option value="Restaurant/Bar">Restaurant/Bar</option>
												<option value="Concessions/Food Service">Concessions/Food Service</option>
												<option value="Maintenance">Maintenance</option>
												<option value="Any">Any</option>
										</Field>
										<Field
												name="dateAvailable"
												wrapperClassName="col-sm-5 required date"
												component={Controls.date}
												props={{
												placeholder: "Date Available",
												label: "Date Available"
										}}/>
								</div>

								{/************************
					* RATE OF PAY/HOURS
					*************************/}
								<div className="row">
										<Field
												name="hoursDesiredPerWeek"
												type="number"
												wrapperClassName="col-sm-5 required"
												component={Controls.input}
												props={{
												label: "Hours Desired per Week",
												placeholder: "# of Hours per week"
										}}/>
								</div>

								{/************************
					* AVAILIBILITY
					*************************/}
								<div className="row no-caps">
										<div className="col-sm-12 no-margin">
												<label className="required">Are you available to work? (Select YES or NO in each box below)</label>
										</div>
								</div>
								<div className="row no-caps">
										<Field
												name="availableHolidays"
												wrapperClassName="col-sm-3 unbold"
												component={Controls.select}
												props={{
												label: "Holidays:",
												placeholder: "Select"
										}}>
												<option value="true">Yes</option>
												<option value="false">No</option>
										</Field>
										<Field
												name="availableDays"
												wrapperClassName="col-sm-3 unbold"
												component={Controls.select}
												props={{
												label: "Days:",
												placeholder: "Select"
										}}>
												<option value="true">Yes</option>
												<option value="false">No</option>
										</Field>
										<Field
												name="availableEvenings"
												wrapperClassName="col-sm-3 unbold"
												component={Controls.select}
												props={{
												label: "Evenings:",
												placeholder: "Select"
										}}>
												<option value="true">Yes</option>
												<option value="false">No</option>
										</Field>
										<Field
												name="availableWeekends"
												wrapperClassName="col-sm-3 unbold"
												component={Controls.select}
												props={{
												label: "Weekends:",
												placeholder: "Select"
										}}>
												<option value="true">Yes</option>
												<option value="false">No</option>
										</Field>
								</div>

								{/************************
					* DESKTOP - DAY OF THE WEEK
					*************************/}
								<p>
										National Amusements theatres are open every day of the year. Please indicate the
										days and hours you are available to work below.
								</p>

								<table className="table has-border d-none d-sm-table">
										<thead>
												<tr>
														<th></th>
														<th>Mon</th>
														<th>Tues</th>
														<th>Wed</th>
														<th>Thurs</th>
														<th>Fri</th>
														<th>Sat</th>
														<th>Sun</th>
												</tr>
										</thead>
										<tbody>
												<tr>
														<td>FROM</td>
														{DaysOfTheWeek.map((day, index) => <td key={index}>
																<Field
																		name={`daysAvailable[${index}].from`}
																		component={Controls.select}
																		props={{
																		hideLabel: true
																}}>
																		{Times.map(time => <option key={time.value} value={time.value}>{time.label}</option>)}
																</Field>
														</td>)
}
												</tr>
												<tr>
														<td>TO</td>
														{DaysOfTheWeek.map((day, index) => <td key={index}>
																<Field
																		name={`daysAvailable[${index}].to`}
																		component={Controls.select}
																		props={{
																		hideLabel: true
																}}>
																		{Times.map(time => <option key={time.value} value={time.value}>{time.label}</option>)}
																</Field>
														</td>)
}
												</tr>
										</tbody>
								</table>

								{/************************
					* MOBILE - DAY OF THE WEEK
					*************************/}
								<div className="d-block d-sm-none mobile-week">
										{DaysOfTheWeek.map((day, index) => <div key={index}>
												<div className="row">
														<div className="col-sm-12 no-margin">
																<label className="day-of-week">{day}</label>
														</div>
												</div>
												<div className="row">
														<Field
																wrapperClassName="col-6 from"
																name={`daysAvailable[${index}].from`}
																component={Controls.select}
																props={{
																label: "From"
														}}>
																{Times.map(time => <option key={time.value} value={time.value}>{time.label}</option>)}
														</Field>
														<Field
																wrapperClassName="col-6 to"
																name={`daysAvailable[${index}].to`}
																component={Controls.select}
																props={{
																label: "To"
														}}>
																{Times.map(time => <option key={time.value} value={time.value}>{time.label}</option>)}
														</Field>
												</div>
										</div>)
}
								</div>

								{/************************
					* PREVIOUS/NEXT
					*************************/}
								<div className="actions">
										<button
												type="button"
												disabled={submitting}
												className="btn btn-default"
												onClick={this.props.goToPrevious}>
												Previous
										</button>
										<button type="submit" disabled={submitting} className="btn btn-primary">
												Next
										</button>
								</div>
						</form>
				);
		}
}

export default reduxForm({form: "employment-application", destroyOnUnmount: false, validate})(EmploymentDesired)
